<template>
  <div>
    <div
      class="notification-card"
      :class="{
        clickable:
          [
            'SalesforceClinicianMessage',
            'SalesforceTooManyRejectedSuggestions',
            'SalesforceAppointmentOptions'
          ].includes(notification.type) || notification.event?.actionUrl?.href
      }"
      @click="handleClick"
    >
      <div class="title brand-text">{{ notification.subject }}</div>
      <div class="body brand-text">{{ notification.body }}</div>
    </div>
    <div class="underline"></div>
  </div>
</template>

<script>
import MeetingRoomModal from "./DMH/Booking/MeetingRoomModal.vue";

const URL_REDIRECT_MAP = {
  "/view-assessments": "/results"
};

export default {
  name: "Notification",
  props: ["notification"],
  methods: {
    handleClick() {
      let shouldCloseNotifications = false;

      if (this.notification.type === "SalesforceAppointmentOptions") {
        this.$router.push(
          "/f2f/" +
            this.notification.event?.salesforce_appointment_options?.sessionId +
            "/" +
            this.notification.id
        );
        shouldCloseNotifications = true;
      } else if (
        this.notification.type === "SalesforceTooManyRejectedSuggestions"
      ) {
        this.$router.push(
          "/message/" +
            this.notification.event?.salesforce_session_suggestions_rejected
              ?.sessionId +
            "/reject"
        );
        shouldCloseNotifications = true;
      } else if (this.notification.type === "SalesforceClinicianMessage") {
        this.$router.push(
          "/message/" +
            this.notification.event?.salesforce_clinician_message
              ?.sf_appointment_id +
            "/reply"
        );
        shouldCloseNotifications = true;
      } else if (
        ["AxaSalesforceBooking", "AxaSalesforceBookingReminder"].includes(
          this.notification.type
        )
      ) {
        if (this.notification.subject === "Booking Confirmed") {
          return this.openBookingModal(
            this.notification.event?.additional_details
          );
        } else {
          this.$emit("open-bookings");
        }
      } else if (this.notification.event?.actionUrl?.href) {
        const href = this.notification.event.actionUrl.href.replace("//", "/");
        // check against hardcoded URL corrections
        const redirectUrl = URL_REDIRECT_MAP[href] || href;
        this.$router.push(redirectUrl);
        shouldCloseNotifications = true;
      }

      // close the notifications panel after redirection
      if (shouldCloseNotifications) {
        this.$emit("close-notifications");
      }
    },
    openBookingModal(booking) {
      // cleanup data into the way MeetingRoomModal expects
      const bookingData = {
        appointmentId: booking?.appointmentId,
        appointmentType: booking?.appointmentType,
        startTime: booking?.startTime,
        endTime: booking?.endTime,
        clinician: booking?.clinician
      };

      const content = this.$createElement(MeetingRoomModal, {
        props: { booking: bookingData }
      });
      const skin = this.$store.getters.skin;
      let opts = {
        title: "My Coaching Session",
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        headerClass:
          "coach_modal_header bg-brand-secondary d-flex justify-content-center",
        size: "lg",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: "digital_clinics_modal"
      };
      return this.$bvModal.msgBoxOk(content, opts);
    }
  }
};
</script>

<style lang="less">
.notification-card {
  padding: 24px;

  &.clickable {
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #eee;
    }
  }

  .icon-holder {
    height: 100%;
    width: 44px;
  }

  .icon {
    width: 41px;
    height: 41px;
    border-radius: 10px;
    font-size: 1.6rem;
    font-family: "FSElliotBold", sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title {
    font-size: 1.6rem;
    font-family: "FSElliotBold", sans-serif;
    margin-bottom: 10px;
  }

  .body {
    font-size: 1.4rem;
    font-family: "FSElliotBook", sans-serif;
  }
}
.underline {
  height: 1px;
  background-color: #e0e5f5;
}
</style>
